import React, { Component } from "react";
import "./Customer.css";
import { Link } from "react-router-dom";
import { Breadcrumb, Alert, PageHeader } from "react-bootstrap";
import ListCustomers from "./ListCustomers";
import NewCustomer from "./NewCustomer";

export default class Customer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      showAlertSuccess: false,
      showAlertError: false,
      alertMessage: '',
      refreshCustomers: false
    };
  }

  handleAlertSuccess = (message) => {
	var newState = { alertMessage: message.message, showAlertSuccess: true };
	if (message.refresh) {
	  newState.refreshCustomers = true;
	}
	this.setState(newState);
	setTimeout(function() { 
      if(this.state.showAlertSuccess){
        this.setState({ showAlertSuccess: false });
      }
    }.bind(this), 3000);
  }
  
  handleDismissSuccess = () => {
	this.setState({ showAlertSuccess: false });
  }

  handleAlertError = (message) => {
    this.setState({ alertMessage: message.message, showAlertError: true });
    setTimeout(function() { 
      if(this.state.showAlertError){
        this.setState({ showAlertError: false });
      }
    }.bind(this), 3000);
  }
  
  handleDismissError = () => {
	this.setState({ showAlertError: false });
  }
  
  render() {
    return (
      <div className="Customer">
        <Breadcrumb>
		    <Breadcrumb.Item componentClass={Link} href="/" to="/">Home</Breadcrumb.Item>
	        <Breadcrumb.Item active>Clientes</Breadcrumb.Item>
		    </Breadcrumb>
        <PageHeader>
          Clientes <small>Configuración</small>
        </PageHeader>
        <NewCustomer {...this.props} onAlertSuccess={this.handleAlertSuccess} onAlertError={this.handleAlertError}/>
        {
        	this.state.showAlertSuccess &&
        	<Alert bsStyle="success" onDismiss={this.handleDismissSuccess}>
        	  <strong>{this.state.alertMessage}</strong>
        	</Alert>
        }
        {
        	this.state.showAlertError &&
        	<Alert bsStyle="danger" onDismiss={this.handleDismissError}>
        	  <strong>{this.state.alertMessage}</strong>
        	</Alert>
        }
        <ListCustomers {...this.props} refresh={this.state.refreshCustomers} onAlertSuccess={this.handleAlertSuccess} onAlertError={this.handleAlertError}/>
      </div>
    );
  }
  
}



// WEBPACK FOOTER //
// ./src/containers/customer/Customer.js